var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50.75px",
    height: "50.5px",
    viewBox: "0 0 50.75 50.5",
    enableBackground: "new 0 0 50.75 50.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.568,32.517c4.365,0,7.917-3.552,7.917-7.918c-0.005-4.358-3.556-7.909-7.917-7.915c-4.365,0-7.916,3.551-7.916,7.916 C17.653,28.965,21.204,32.517,25.568,32.517z M21.457,24.6c0-2.267,1.844-4.111,4.111-4.111c2.267,0,4.11,1.844,4.11,4.11 c-0.002,2.266-1.847,4.11-4.11,4.112C23.301,28.711,21.457,26.867,21.457,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.648,23.44c-0.346-0.496-8.613-12.14-23.08-12.14C11.125,11.3,2.835,22.943,2.49,23.438l-0.367,0.523v2.461 l0.425,0.549c0.346,0.446,8.631,10.93,23.02,10.93c14.4,0,22.675-10.483,23.021-10.93l0.425-0.549v-2.461L48.648,23.44z  M25.568,15.354c10.444,0,17.345,7.428,19.258,9.769c-1.961,2.134-8.862,8.722-19.258,8.722s-17.294-6.586-19.256-8.72 C8.223,22.782,15.11,15.354,25.568,15.354z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9baf1d01.svg";
export { ForwardRef as ReactComponent };